<template>
  <BaseBody>
    <BaseTopBar>
      <BaseTopBarContent className="left">
        {{ $t('sidebar.employee') }} > {{ employee.name }}
      </BaseTopBarContent>
      <BaseTopBarContent className="right">
        <div
          v-if="!loading"
          class="action">
          <BaseActionDropdown
            v-if="hasRoleDelete"
            :icon="`fas fa-cog`"
            :text="$t('button.options')"
            :items="[
              {
                icon: 'fas fa-trash',
                iconClassName: 'text-danger',
                text: $t('button.delete'),
                textClassName: 'text-danger',
                value: 'delete',
              }
            ]"
            @onSelect="handleSelectOption"
          />
        </div>
      </BaseTopBarContent>
    </BaseTopBar>
    <BaseContent :loading="loading">
      <HrmEmployeeForm
        :state="employee"
        :isSubmitted="isSubmitted"
        :departments="departments"
        :positions="positions"
        :disabled="disabled || !hasRoleEdit"
        :form.sync="form"
        :showActionButtons="hasRoleEdit"
        @onSubmit="handleSubmit"
      />

      <baseConfirmDeleteModal
        :show="modal.show"
        :loading="modal.loading"
        @onClose="handleCloseModal"
        @onCancel="handleCancleModal"
        @onSubmit="handleSumitModal"
      />
      <BaseConfirmDiscardModal
        :show="confirmDiscardModal.show"
        @onCancel="handleDiscardCancleModal"
        @onConfirm="handleDiscardConfirmModal"
      />
    </BaseContent>
  </BaseBody>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import { toISODateString } from '@/helpers'
import sidebarModule from './../../sidebarModule'
import discardFormMixin from '@/mixins/discardForm'
import userPermissionMixin from '@/mixins/userPermission'

export default {
  mixins: [discardFormMixin, userPermissionMixin],
  data () {
    return {
      loading: true,
      isSubmitted: false,
      disabled: false,
      query: {
        id: this.$route.query.id,
        name: this.$route.query.name,
      },
      modal: {
        show: false,
        loading: false,
      },
      form: null,
    }
  },

  computed: {
    ...mapState('hrm', {
      departments: 'departmentList',
      positions: 'positionList',
      employee: 'employeeSingle',
    }),
    ...mapGetters({
      sidebar: 'getSidebar',
    }),
  },

  async created () {
    this.fetchData()
  },

  beforeMount () {
    this.initPage({
      section: 'app',
      name: this.$t('app.hrm.title'),
      current: {
        app_name: 'hrm',
        app_id: 13,
        module_id: 1,
      },
    })
    sidebarModule.init(this.getObject(require('../sidebar.json')))
    sidebarModule.update(this.sidebar, 0, [{
      'name': this.query.name,
      'router': {
        'name': 'EmployeeEdit',
        'query': {
          id: this.query.id,
          name: this.query.name,
        },
      },
      'activeClass': 'active',
    }], {
      sidebarAtIdx: 0,
      submenuAtIdx: 2,
    })
  },

  destroyed () {
    this.leavePage(this.$Progress, [])
  },

  methods: {
    ...mapActions('hrm', {
      getDepartmentList: 'getDepartmentList',
      getPositionList: 'getPositionList',
      getEmployeeSingle: 'getEmployeeSingle',
      updateEmployee: 'updateEmployee',
      deleteEmployee: 'deleteEmployee',
    }),
    async fetchData () {
      this.loading = true
      const params = { page: 1, limit: 100000 }
      await Promise.all([
        this.getDepartmentList(params),
        this.getPositionList(params),
        this.getEmployeeSingle(this.query.id),
      ])
      this.loading = false
      this.showFinish(this.$Progress)
    },
    async handleSubmit (form) {
      const data = {
        'name': form.name,
        'gender': form.gender,
        'birthdate': toISODateString(form.birthdate),
        'department_id': form.departmentId,
        'position_id': form.positionId,
        'contacts': (() => {
          const items = []
          if (form.tel) {
            items.push({ platform: 'tel', source: form.tel })
          }
          if (form.email) {
            items.push({ platform: 'email', source: form.email })
          }
          return items
        })(),
        'address': form.address,
        'wage_amount': form.wageAmount,
        'wage_type': form.wageType,
        'start_working_date': toISODateString(form.startWorkingDate),
        'note': form.note,
        'tags': form.tags,
      }
      this.disabled = true
      this.isSubmitted = true
      const response = await this.updateEmployee({ id: this.query.id, data })
      if (response.success) {
        this.disabled = false
        this.isSubmitted = false
        this.notify(this.$vs, {
          text: this.$t('message.hasbeenupdated', { msg: form.name }),
          color: 'success',
          icon: 'cloud',
        })
        this.fetchData()
      }
    },
    handleSelectOption (value) {
      if (value === 'delete') {
        this.onOpenModal()
      }
    },
    onOpenModal () {
      this.modal.show = true
    },
    handleCloseModal () {
      this.modal.show = false
    },
    handleCancleModal () {
      this.modal.show = false
    },
    async handleSumitModal () {
      this.modal.loading = true
      const response = await this.deleteEmployee(this.query.id)
      if (response.success) {
        this.notify(this.$vs, {
          text: this.$t('message.hasbeendeleted', { msg: this.employee.name }),
          color: 'danger',
          icon: 'delete',
        })
        this.modal.loading = false
        this.modal.show = false
        this.$router.push({ name: 'EmployeeList' })
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/apps/hrm/employee/Edit.vue